import { useEffect } from "react";

export const StructuredData: React.FC = () => {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "Bricksup",
      description:
        "Convert images to LEGO brick mosaics with step-by-step building instructions",
      url: "https://bricksup.com",
      applicationCategory: "DesignApplication",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
      featureList: [
        "Image upload and processing",
        "LEGO color mapping",
        "Pixel art conversion",
        "Step-by-step building instructions",
        "3D visualization",
        "Bill of materials export",
      ],
      inLanguage: ["en", "zh-CN", "zh-TW", "ja", "ko"],
      browserRequirements:
        "Requires JavaScript. Works in all modern browsers.",
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return null;
};
